import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, arrayOf, bool } from "prop-types";
import { isIOS } from "react-device-detect";

import { selectors as investmentfundsSelectors } from "reducers/investmentfunds";
import * as i18n from "util/i18n";

import PageLoading from "pages/_components/PageLoading";
import Notification from "pages/_components/Notification";
import { MobileButtons } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import CustomProductHead from "pages/_components/CustomProductHead";
import CustomText from "pages/_components/CustomText/CustomText";

import Action from "pages/_components/Action";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";

// Plantilla fija para columnas: ajusta los valores según diseño
const COLUMN_TEMPLATE = "1fr 1fr 1fr";
const CENTER_STYLE = { justifyItems: "center", alignItems: "center", gridTemplateColumns: COLUMN_TEMPLATE };

class ListFCIs extends Component {
    static propTypes = {
        fetching: bool.isRequired,
        fcis: arrayOf(shape({})),
        isDesktop: bool.isRequired,
    };

    static defaultProps = {
        fcis: [],
    };

    renderMenuOption = () => {
        const { isDesktop } = this.props;
        return isDesktop ? (
            <div className="toolbar-item add-button">
                {/*
                <CustomButton
                    func={() => dispatch(push("/holdings"))}
                    className="btn btn-primary btn-block"
                    icon={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/nuevo.svg"}
                    text="investmentFunds.fci.new"
                    textType="I18N"
                />
                    */}
            </div>
        ) : (
            <MobileButtons image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                <Action labelKey="investmentFunds.fci.new" to="/holdings" />
            </MobileButtons>
        );
    };

    render() {
        const { fetching, fcis, isDesktop } = this.props;
        const list = Array.isArray(fcis) ? fcis : [];

        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />

                <CustomProductHead
                    titleId="investmentFunds.fci.title"
                    backLinkTo="/holdings"
                    addLinkToLabel="investmentFunds.fci.new"
                    addLinkTo="/applyForLoan"
                    className="deposits"
                    renderMenuOption={this.renderMenuOption}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id="investmentFunds.fci.title" />
                    </div>
                </CustomProductHead>

                <MainContainer className="mt-0">
                    {list.map((rowData) => (
                        <div key={rowData.accountNumber}>
                            <div className="account-type">
                                <CustomText
                                    text={i18n.get("investmentFunds.dashboard.FCI.accountNumber", null, {
                                        ACCOUNT_NUMBER: rowData.accountNumber.replace(/^(0)+/, ""),
                                    })}
                                    textType="STRING"
                                />
                            </div>

                            <GridTable className="scrollable section-accounts text-neutral underlined">
                                {isDesktop && (
                                    <GridTable.Header style={{ position: "sticky", top: 0 }}>
                                        <GridTable.Container style={CENTER_STYLE}>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <I18n id="investmentFunds.fci.fund" />
                                            </GridTable.Data>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <I18n id="investmentFunds.fci.quotePart" />
                                            </GridTable.Data>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <I18n id="investmentFunds.fci.amount" />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable.Header>
                                )}

                                <GridTable.Body>
                                    {rowData.listaPorEspecie?.map((data) => (
                                        <GridTable.Container key={data.especie.codigo} style={CENTER_STYLE}>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <CustomText text={data.especie.descripcion || "-"} textType="TEXT" />
                                            </GridTable.Data>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <CustomText text={data.especie.precio} textType="TEXT" />
                                            </GridTable.Data>
                                            <GridTable.Data alignX="center" alignY="center">
                                                <CustomText text={rowData.totalBalance} textType="ARS" />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    ))}
                                </GridTable.Body>
                            </GridTable>

                            <div className="pb-6" />
                        </div>
                    ))}
                </MainContainer>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    fcis: investmentfundsSelectors.getFci(state),
});

export default connect(mapStateToProps)(ListFCIs);
